module.exports = __webpack_public_path__ + "media/images/icons/Favorite-f9d5a5ce5afbe84fedc8570e3444399c.svg";